// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var container = "careers-module--container--5gkSx";
export var textAndImageContainer = "careers-module--textAndImageContainer--CIyBQ";
export var textContainer = "careers-module--textContainer--QV4gD";
export var title = "careers-module--title--2PNCi";
export var text = "careers-module--text--r3gPT";
export var imageContainer = "careers-module--imageContainer--Gv3sQ";
export var image = "careers-module--image--26KUE";
export var featuredTextContainer = "careers-module--featuredTextContainer--1B6mO";
export var featuredContent = "careers-module--featuredContent--3CCNv";
export var featuredTitle = "careers-module--featuredTitle--3pcGX";
export var featuredText = "careers-module--featuredText--2i1zb";
export var button = "careers-module--button--2JKd3";
export var disabled = "careers-module--disabled--1HWd0";
export var halfTreeContainer = "careers-module--halfTreeContainer--1zUqN";
export var floatingApplyButton = "careers-module--floatingApplyButton--1AYxM";
export var floatingApplyButtonVisible = "careers-module--floatingApplyButtonVisible--2WB-Q";